import { keyBy } from 'lodash';
import sdk from '../../qoc-sdk';

export const types = {
  ON_FETCH_LOGIN_STATUS_FULFILLED: 'ON_FETCH_LOGIN_STATUS_FULFILLED',
  ON_FETCH_LOGIN_STATUS_PENDING: 'ON_FETCH_LOGIN_STATUS_PENDING',
  ON_FETCH_LOGIN_STATUS_REJECTED: 'ON_FETCH_LOGIN_STATUS_REJECTED',

  ON_FETCH_LOGIN_STATUSES_FULFILLED: 'ON_FETCH_LOGIN_STATUSES_FULFILLED',
  ON_FETCH_LOGIN_STATUSES_PENDING: 'ON_FETCH_LOGIN_STATUSES_PENDING',
  ON_FETCH_LOGIN_STATUSES_REJECTED: 'ON_FETCH_LOGIN_STATUSES_REJECTED',

  ON_LOGIN_FULFILLED: 'ON_LOGIN_FULFILLED',
  ON_LOGIN_PENDING: 'ON_LOGIN_PENDING',
  ON_LOGIN_REJECTED: 'ON_LOGIN_REJECTED',

  ON_LOGOUT_FULFILLED: 'ON_LOGOUT_FULFILLED',
  ON_LOGOUT_PENDING: 'ON_LOGOUT_PENDING',
  ON_LOGOUT_REJECTED: 'ON_LOGOUT_REJECTED'
};

const onFetchLoginStatusFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_LOGIN_STATUS_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchLoginStatusRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_LOGIN_STATUS_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchLoginStatus = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_LOGIN_STATUS_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getLoginStatus(requestProps)
    .then(response => {
      const { status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onFetchLoginStatusFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchLoginStatusRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

const onFetchLoginStatusesFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_LOGIN_STATUSES_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchLoginStatusesRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_LOGIN_STATUSES_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchLoginStatuses = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_LOGIN_STATUSES_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getLoginStatuses(requestProps)
    .then(response => {
      const { data, status, statusText } = response;
      const loginStatuses = data.loginStatuses || {};

      if (status === 200) {
        return dispatch(
          onFetchLoginStatusesFulfilled({
            fulfillCallback,
            loginStatuses: keyBy(loginStatuses, 'loginStatus'),
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchLoginStatusesRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

const onLoginFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_LOGIN_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onLoginRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_LOGIN_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onLogin = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_LOGIN_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .login(requestProps)
    .then(response => {
      const { status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onLoginFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onLoginRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

const onLogoutFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_LOGOUT_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onLogoutRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_LOGOUT_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onLogout = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_LOGOUT_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .logout(requestProps)
    .then(response => {
      const { status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onLogoutFulfilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onLogoutRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};



// WEBPACK FOOTER //
// ./src/qoc-redux/Authentication/actions.js